import * as React from "react";
import { usePimEyes } from "./usePimEyes";
import { useBingSearch } from "./useBingSearch";
import { useTinEye } from "./useTinEye";
import { VisualSearchProviders, VisualSearchActions } from "src/share/types/visualSearch";

const { useEffect } = React;

const providerHooks = {
  [VisualSearchProviders.PIMEYES]: usePimEyes,
  [VisualSearchProviders.TINEYE]: useTinEye,
  [VisualSearchProviders.BING]: useBingSearch
};

const useProvider = (provider) => {
  const { state, actions } = providerHooks[provider]();
  useEffect(() => {
    actions.dispatch({ type: VisualSearchActions.reset });
    if(state.thumbnail) {
      actions.fetchImages(state.thumbnail, state.by);
    }
  }, [provider, state.thumbnail, state.by]);
  return {
    state,
    actions: { ...actions },
  };
}

export default useProvider;



// WEBPACK FOOTER //
// ./src/modules/AdHocTools/VisualSearch/hooks/useProvider.tsx